/* Running Shoes House - coloris de la fiche produit, en vraies photos produit. */
(function () {
  'use strict';

  var box = document.querySelector('[data-pdp-colors]');
  if (!box || !window.fetch) return;

  var LEX = ('black white grey gray green blue red pink orange yellow purple violet navy cream beige brown khaki ' +
    'light dark silver gold ivory olive teal mint sand storm glacier tide tundra bone flax onyx resin azure marsh ' +
    'dew frost pearl wolf alloy cinder eclipse seedling limelight truffle nebula ghost tin twilight rock brook ' +
    'iceberg nimbus winter kasha graphite ink salmon cyan lime coral aqua crimson volt anthracite mushroom sail ' +
    'smoke smokey oatmeal oatmilk gypsum summit particle guava sunset seaweed cannon foam hero pulse caldera ' +
    'reverse swoosh barely metallic sky sea espresso safari midnight gobi seashell flint honeydew asphalt pelican ' +
    'dust sienna thistle horizon peony foxglove dijon pebble oyster camellia sunstone aquamarine platinum myrtle ' +
    'squash cascade sailor linen heather stone lilac mauve gardenia lily cobalt tangerine juniper magnet ray ' +
    'verdite apollo flurry tomato walnut castleroc rosemary bark charcoal chalk scarlet lemon').split(' ');

  var CACHE_KEY = 'rp_pdp_colors_v1';

  function currentHandle() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  function titleCase(handle) {
    return handle.split('-').map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
  }

  function escapeRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  function buildGroups(products) {
    var colourWord = {};
    LEX.forEach(function (w) { colourWord[w] = 1; });

    function hasColourOption(p) {
      return (p.options || []).some(function (o) { return /couleur|color/i.test(o.name || ''); });
    }

    products.forEach(function (p) {
      if (!hasColourOption(p)) return;
      (p.options || []).forEach(function (o) {
        if (!/couleur|color/i.test(o.name || '')) return;
        (o.values || []).forEach(function (v) {
          String(v).toLowerCase().split(/[^a-z0-9]+/).forEach(function (t) { if (t) colourWord[t] = 1; });
        });
      });
    });

    var pool = products.filter(function (p) { return !hasColourOption(p); });

    var prefixCount = {};
    pool.forEach(function (p) {
      var seg = p.handle.split('-');
      for (var n = 2; n < seg.length; n++) {
        var pre = seg.slice(0, n).join('-');
        prefixCount[pre] = (prefixCount[pre] || 0) + 1;
      }
    });

    var baseOf = {};
    pool.forEach(function (p) {
      var seg = p.handle.split('-');
      var base = null;
      for (var n = seg.length - 1; n >= 2; n--) {
        var pre = seg.slice(0, n).join('-');
        if (prefixCount[pre] >= 2) { base = pre; break; }
      }
      baseOf[p.handle] = base;
    });

    var known = {};
    Object.keys(baseOf).forEach(function (h) { if (baseOf[h]) known[baseOf[h]] = 1; });

    function collapse(base) {
      if (!base) return base;
      var seg = base.split('-');
      while (seg.length > 2 && colourWord[seg[seg.length - 1]]) {
        var parent = seg.slice(0, -1).join('-');
        if (known[parent]) seg.pop(); else break;
      }
      return seg.join('-');
    }

    var groups = {};
    pool.forEach(function (p) {
      var base = baseOf[p.handle];
      if (!base) return;
      var key = collapse(base);
      var image = (p.images && p.images[0] && p.images[0].src) || '';
      image = image.split('?')[0];
      var colour = p.title.replace(new RegExp('^' + escapeRe(titleCase(key)), 'i'), '').replace(/^[\s\-–—'"]+/, '').trim();
      (groups[key] = groups[key] || []).push({ handle: p.handle, image: image, colour: colour || p.title });
    });

    var out = {};
    Object.keys(groups).forEach(function (k) { if (groups[k].length >= 2) out[k] = groups[k]; });
    return out;
  }

  function loadGroups(done) {
    try {
      var cached = window.sessionStorage.getItem(CACHE_KEY);
      if (cached) {
        var parsed = JSON.parse(cached);
        if (parsed && Object.keys(parsed).length) { done(parsed); return; }
      }
    } catch (e) {}

    var all = [];
    var page = 1;

    function step() {
      window.fetch('/products.json?limit=250&page=' + page, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.products && d.products.length) {
            all = all.concat(d.products);
            page++;
            if (page <= 5 && d.products.length === 250) step(); else finish();
          } else finish();
        })
        .catch(finish);
    }

    function finish() {
      var groups = buildGroups(all);
      try {
        if (groups && Object.keys(groups).length) {
          window.sessionStorage.setItem(CACHE_KEY, JSON.stringify(groups));
        }
      } catch (e) {}
      done(groups);
    }

    step();
  }

  function sizeUrl(src, width) {
    if (!src) return src;
    return src.replace(/(\.(?:jpg|jpeg|png|webp))(?=$|\?)/i, '_' + width + 'x$1');
  }

  function render(groups) {
    var handle = currentHandle();
    if (!handle) return;

    var members = null;
    Object.keys(groups).some(function (key) {
      var found = groups[key].some(function (m) { return m.handle === handle; });
      if (found) { members = groups[key]; return true; }
      return false;
    });
    if (!members || members.length < 2) return;

    var list = box.querySelector('[data-pdp-colors-list]');
    var count = box.querySelector('[data-pdp-colors-count]');
    if (!list) return;

    var preview = window.location.search.match(/[?&]preview_theme_id=(\d+)/);
    var query = preview ? '?preview_theme_id=' + preview[1] : '';

    var html = '';
    members.forEach(function (m) {
      var active = m.handle === handle ? ' is-current' : '';
      var label = String(m.colour).replace(/"/g, '');
      html += '<a class="pdp__swatch' + active + '" href="/products/' + m.handle + query +
        '" title="' + label + '" aria-label="' + label + '">' +
        '<img src="' + sizeUrl(m.image, 240) + '" alt="' + label + '" width="240" height="240" loading="lazy"></a>';
    });

    list.innerHTML = html;
    if (count) count.textContent = '· ' + members.length + ' available';
    box.hidden = false;
  }

  loadGroups(render);
})();
